import SearchWithStartIcon from 'assets/Icons/Zai/SearchWithStartIcon';
import React, { FC } from 'react';
import { BiX } from 'react-icons/bi';

interface Props {
  onChange: (v: string) => void;
  value: string;
}
const Icon: FC<Props> = ({ onChange, value }) => {
  return (
    <>
      {value.length ? (
        <BiX
          onClick={() => onChange('')}
          className='w-[18px] h-[18px] text-grayZl-600 cursor-pointer'
        />
      ) : (
        <SearchWithStartIcon className='min-w-[18px] min-h-[18px] ' />
      )}
    </>
  );
};

export default Icon;
